import GeoreferencedSearchProvider from "./context/georeferenced-search-context.jsx";
import GeoreferencedSearchIndex from "./georeferenced-search-index.jsx";

const GeoreferencedSearchPage = () => (
    <GeoreferencedSearchProvider>
        <GeoreferencedSearchIndex />
    </GeoreferencedSearchProvider>
);

export default GeoreferencedSearchPage;